/**
 * @generated SignedSource<<2b8efdea78119fc4387d0c35514b8302>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type interiorsModuleHelpers_interiorPhotos$data = {
  readonly photoSearchParam: {
    readonly name: string | null;
  } | null;
  readonly " $fragmentType": "interiorsModuleHelpers_interiorPhotos";
};
export type interiorsModuleHelpers_interiorPhotos$key = {
  readonly " $data"?: interiorsModuleHelpers_interiorPhotos$data;
  readonly " $fragmentSpreads": FragmentRefs<"interiorsModuleHelpers_interiorPhotos">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "interiorsModuleHelpers_interiorPhotos"
};

(node as any).hash = "983cc22422edafbc44eb8baaeff21fa7";

export default node;
